import React from 'react';
import { Button } from '../../Atoms';

interface FailModalProps {
    isOpen: boolean;
    onClose: (result: { reason: string; notes: string } | null) => void;
    name: string;
    handleSubmit: () => Promise<void>;
    disabled?: boolean;
}

const FailModal: React.FC<FailModalProps> = ({ isOpen, onClose, name, handleSubmit, disabled }) => {

    const onHandleSubmit = async () => {
        try {
            await handleSubmit();
        } catch (error) {
            console.error('Error submitting fail reason:', error);
            onClose(null);
        }
    };

    const handleCancelOnClick = () => {
        onClose(null);
    };

    if (!isOpen) return null;

    return (
        <div className="complete-modal complete-modal modal-overlay" onClick={() => onClose(null)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className='modal-form'>
                    <div className='form-content'>
                        <h1 className='modal-header'>{name}</h1>
                        <div className='content'>
                            <p>
                                When you complete the POA for this patient, the outcome will be set to <span className="highlight">Fail</span>
                            </p>
                            <p>
                                A PDF of the POA will be downloaded, and needs to be added to TrakCare
                            </p>
                        </div>
                    </div>
                    <div className='button-container button-container-triage-list button-spacing'>
                        <Button
                            type='tertiary'
                            text="Complete this POA"
                            icon={false}
                            handleClick={onHandleSubmit}
                            stateProp={disabled ? 'disabled' : 'enabled'}
                        />
                        <Button
                            type='primary'
                            text="Cancel"
                            icon={false}
                            handleClick={handleCancelOnClick}
                            stateProp='enabled'
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FailModal;
